import React,{useState,useRef,useEffect} from 'react'
import { makeAuthenticatedPost, makeAuthenticatedPostForFile } from '../utils/fetchUtils';
import { UPLOAD_FILE_WITH_USER_INFO } from '../utils/constants';

const AddUsers =()=> {


    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading , setLoading] = useState(false);
    const [message , setMessage] = useState("");

  const handleButtonClick = (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    if (fileInputRef.current) {
        fileInputRef.current.click();
    } else {
        console.error("fileInputRef is null.");
    }
  };

  const handleFileChange = (event:any)=>{
    const file = event.target.files?.[0];
    setSelectedFile(file);
  }

  const handleFileUpload = async ()=>{
    try {
        if(selectedFile){
            setLoading(true);
            const formData = new FormData();
            formData.append('file',selectedFile);
            // console.log(selectedFile);
            const response =await makeAuthenticatedPostForFile(UPLOAD_FILE_WITH_USER_INFO,formData);
            if(response.success===true){
                setMessage("Phone numbers are whitelisted!");
            }else{
                setMessage("some error occured while fetching numbers from the file!");
            }
            
            // console.log(response);
        }
    } catch (error:any) {
        if(error.response && error.response.data)
        {
            setMessage(error.response.data.message);
        }
        // console.log("error while uploading file",error);
    } finally{
        setLoading(false);
        // setSelectedFile(null);
    }
  }

  return (
    <div>
           <div className="flex justify-center ">
                <button className="btn relative p-0 text-black dark:text-white mt-12" aria-label="Attach the Csv file " onClick={handleButtonClick}>
                    <div className="flex w-full gap-2 items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z" fill="currentColor"></path>
                        </svg>
                        <p className="text-white">Attach the Csv file</p>
                    </div>
                </button>
                <input  
                ref={fileInputRef} 
                type="file" 
                tabIndex={-1} 
                className="hidden" 
                style={{ display: 'none' }} 
                onChange={handleFileChange}
                />
           </div>
           <div className="flex flex-col items-center justify-center mt-6">
                <p>{selectedFile?selectedFile.name:''}</p>
                {
                    selectedFile && <button className='bg-[#A643FE] w-[18.75rem] h-[2.5rem] rounded mt-6' onClick={handleFileUpload}>Upload The file</button>
                }
                <p className='mt-6'>{message}</p>
           </div>
    </div>
  )
}

export default AddUsers